import { BLACK_800, BLACK_900, BLUE_GREY_200, BLUE_GREY_400, GREEN_200, GREEN_400, LILAC_400, LILAC_800, RED_200, RED_400, WHITE, YELLOW_200, YELLOW_400 } from './../colors';
var calloutConfig = {
  theme: 'light',
  title: '',
  ctaText: '',
  description: '',
  state: 'default',
  isLoading: false,
  iconName: '',
  iconProps: {
    height: 24,
    width: 24
  },
  version: 'variable-width',
  showCrossDismissBtn: false,
  onDismissHandler: () => null,
  config: {
    state: {
      default: {
        backgroundColor: BLACK_800,
        borderColor: BLACK_900,
        crossDismissIconProps: {
          color: WHITE,
          height: '24',
          width: '24'
        },
        iconProps: {
          color: WHITE,
          height: 24,
          width: 24
        },
        titleColor: WHITE,
        descriptionColor: WHITE,
        ctaTheme: 'light'
      },
      success: {
        backgroundColor: GREEN_200,
        borderColor: GREEN_400,
        crossDismissIconProps: {
          color: BLACK_900,
          height: '24',
          width: '24'
        },
        iconProps: {
          color: BLACK_900,
          height: 24,
          width: 24
        },
        titleColor: BLACK_900,
        descriptionColor: BLACK_900,
        ctaTheme: 'dark'
      },
      error: {
        backgroundColor: RED_200,
        borderColor: RED_400,
        crossDismissIconProps: {
          color: BLACK_900,
          height: '24',
          width: '24'
        },
        iconProps: {
          color: BLACK_900,
          height: 24,
          width: 24
        },
        titleColor: BLACK_900,
        descriptionColor: BLACK_900,
        ctaTheme: 'dark'
      },
      warning: {
        backgroundColor: YELLOW_200,
        borderColor: YELLOW_400,
        crossDismissIconProps: {
          color: BLACK_900,
          height: '24',
          width: '24'
        },
        iconProps: {
          color: BLACK_900,
          height: 24,
          width: 24
        },
        titleColor: BLACK_900,
        descriptionColor: BLACK_900,
        ctaTheme: 'dark'
      },
      lilac: {
        backgroundColor: LILAC_400,
        borderColor: LILAC_800,
        crossDismissIconProps: {
          color: BLACK_900,
          height: '24',
          width: '24'
        },
        iconProps: {
          color: BLACK_900,
          height: 24,
          width: 24
        },
        titleColor: BLACK_900,
        descriptionColor: BLACK_900,
        ctaTheme: 'dark'
      }
    }
  }
};
var calloutWhiteConfig = Object.assign(Object.assign({
  theme: 'white'
}, calloutConfig), {
  config: {
    state: {
      default: {
        backgroundColor: BLACK_800,
        borderColor: BLACK_900,
        crossDismissIconProps: {
          color: WHITE,
          height: '24',
          width: '24'
        },
        iconProps: {
          color: WHITE,
          height: 24,
          width: 24
        },
        titleColor: WHITE,
        descriptionColor: WHITE,
        ctaTheme: 'light'
      },
      success: {
        backgroundColor: GREEN_200,
        borderColor: GREEN_400,
        crossDismissIconProps: {
          color: BLACK_900,
          height: '24',
          width: '24'
        },
        iconProps: {
          color: BLACK_900,
          height: 24,
          width: 24
        },
        titleColor: BLACK_900,
        descriptionColor: BLACK_900,
        ctaTheme: 'dark'
      },
      error: {
        backgroundColor: RED_200,
        borderColor: RED_400,
        crossDismissIconProps: {
          color: BLACK_900,
          height: '24',
          width: '24'
        },
        iconProps: {
          color: BLACK_900,
          height: 24,
          width: 24
        },
        titleColor: BLACK_900,
        descriptionColor: BLACK_900,
        ctaTheme: 'dark'
      },
      warning: {
        backgroundColor: YELLOW_200,
        borderColor: YELLOW_400,
        crossDismissIconProps: {
          color: BLACK_900,
          height: '24',
          width: '24'
        },
        iconProps: {
          color: BLACK_900,
          height: 24,
          width: 24
        },
        titleColor: BLACK_900,
        descriptionColor: BLACK_900,
        ctaTheme: 'dark'
      },
      lilac: {
        backgroundColor: BLUE_GREY_200,
        borderColor: BLUE_GREY_400,
        crossDismissIconProps: {
          color: BLACK_900,
          height: '24',
          width: '24'
        },
        iconProps: {
          color: BLACK_900,
          height: 24,
          width: 24
        },
        titleColor: BLACK_900,
        descriptionColor: BLACK_900,
        ctaTheme: 'dark'
      }
    }
  }
});
export default {
  light: calloutConfig,
  dark: calloutConfig,
  white: calloutWhiteConfig
};